import { render, staticRenderFns } from "./AdBlock.vue?vue&type=template&id=2c16d1fe&scoped=true"
import script from "./AdBlock.vue?vue&type=script&lang=js"
export * from "./AdBlock.vue?vue&type=script&lang=js"
import style0 from "./AdBlock.vue?vue&type=style&index=0&id=2c16d1fe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16d1fe",
  null
  
)

export default component.exports